import React from 'react';
import '../styles/OrderCompletedModal.css';

const OrderCompletedModal=({message,onView,onClose})=>{
  return (
    <div className="oc-modal-overlay">
      <div className="oc-modal-content">
        <p>{message}</p>
        <div className='oc-btn'>
            <button onClick={onView}>View Orders</button>
            <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default OrderCompletedModal;